/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isNumberNaN
 */

export default function isNumberNaN(value) {
  return value !== value;
}
